import axios from "axios";
import { config } from "../config";
import { encryptService } from "./encrypt-service";

import reduxStore from "../redux/store";

const getAuth = () => {
  return reduxStore.getState().renewal;
};

const instance = axios.create({
  baseURL: config.apiUrl,
  // timeout: 1000,
  // headers: {'Content-Type': 'application/json','Accept':'application/json'}
});

export const securedInstance = axios.create({
  baseURL: config.apiUrl,
});

securedInstance.interceptors.request.use(
  (config) => {
    const { jwt, authToken, requestId } = getAuth();
    config.headers.jwt = jwt;
    config.headers.authToken = authToken;
    config.headers.requestId = requestId;
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
